import { EmploymentRecordEntity } from 'src/store/employment-record/employment-record.model';
import { PrdProcessingState } from './pilot-view-model';

export function createPrdSeparationTypes() {
  const codes = {
    TERMPP: 'Termination - Pilot  Performance',
    TERMPD: 'Termination – Professional Disqualification',
    OtherEmp: 'Other - Employer initiated separation not due to pilot performance',
    OtherPhys: 'Other – Physical/ Medical Disqualification',
    OtherResg: 'Other - Resignation',
    OtherRetr: 'Other - Retirement',
    Other: 'Other - Details',
  };
  const separationTypes = Object.keys(codes).map((code) => ({
    code: code as keyof typeof codes,
    description: codes[code as keyof typeof codes],
  }));
  return {
    separationTypes,
    codeToDescription: (code: keyof typeof codes) => codes[code],
    isOther: (code: keyof typeof codes) => codes[code] === codes.Other,
  };
}

export class EmploymentRecordViewModel implements EmploymentRecordEntity {
  public id: string;
  public pilotId: string;
  public prdSourceSystemId: string;
  public prdDateOfHire: Date;
  public completeDate: Date;
  public finalRecordsDate: Date;
  public separationDate: Date;
  public separationType: string;
  public separationTypeDetail: string;
  public relevantDocuments: boolean;
  public processingState: PrdProcessingState;
  public processingError: string;
  public lastProcessedDate: Date;

  constructor(employmentRecord: EmploymentRecordEntity) {
    Object.assign(this, employmentRecord);
  }
}
